import * as React from "react";
import { MantineProvider, MantineThemeOverride } from "@mantine/core";

interface Props {
	theme: MantineThemeOverride;
	/**
	Children rendered in the main area
  	*/
	children?: React.ReactNode;
}

const VSETHThemeProvider: React.FC<Props> = ({ theme, children }) => {
	return (
		<MantineProvider theme={theme} withGlobalStyles withNormalizeCSS>
			{children}
		</MantineProvider>
	);
};

export default VSETHThemeProvider;
